import { Badge, Button, cn } from "@workspace/frontend-ui";
import type { FC } from "react";
import type { SelectedProvider } from "../../types";
import ProviderFilterChip from "./ProviderFilterChip";

type Props = {
  providers: SelectedProvider[];
  activeProviderFilter: SelectedProvider[];
  providerCounts: Record<string, number>;
  allCount: number;
  onToggleTab: (provider: SelectedProvider) => void;
  onClearTab: () => void;
  onRemoveProvider: (provider: SelectedProvider) => void;
};

const ProviderFilterChips: FC<Props> = ({
  providers,
  activeProviderFilter,
  providerCounts,
  allCount,
  onToggleTab,
  onClearTab,
  onRemoveProvider,
}) => (
  <div className="flex w-full flex-wrap items-center gap-2">
    {providers.length > 0 && (
      <Button
        variant={activeProviderFilter.length > 0 ? "secondary" : "unstyled"}
        className={cn(
          "rounded-full h-10 pl-4 pr-2 shadow-none",
          activeProviderFilter.length === 0 && "border border-primary!",
        )}
        onClick={onClearTab}
      >
        All
        <Badge>{allCount}</Badge>
      </Button>
    )}
    {providers.map((provider) => (
      <ProviderFilterChip
        key={provider.name}
        provider={provider}
        count={providerCounts[provider.name?.toLowerCase()] || 0}
        isActive={activeProviderFilter.some((p) => p.name === provider.name)}
        onToggleTab={onToggleTab}
        onRemove={onRemoveProvider}
      />
    ))}
  </div>
);

export default ProviderFilterChips;
